import { render, staticRenderFns } from "./TraplinkedIdOfObjekt.vue?vue&type=template&id=59ea2b31"
import script from "./TraplinkedIdOfObjekt.vue?vue&type=script&lang=js"
export * from "./TraplinkedIdOfObjekt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports